/* eslint-disable max-len */
import React, {Component, Fragment} from 'react';
import moment from 'moment';
import createJTDealerRefundOrderMutation from 'graphql/mutations/orders/create-jt-dealer-refund-order.gql';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import AddressGrid from 'components/address-grid';
import {getDefaultAddress} from 'core/utils';
import {Form, Field, Input, Textarea, DateInput, LocalitySelect, Toggle} from 'components/forms';
import {gt} from 'components/forms/form/validators';
import Button from 'components/button';
import {refundForm} from 'components/forms/decorators';
import styles from './styles.css';

@refundForm(createJTDealerRefundOrderMutation, {loadAddresses: true})
export default class JTDealerRefundCreate extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='Jornadas Técnicas' />
                <Form
                    fields={this.props.populateInitial([
                        {key: 'estimatedAmount', validators: [gt(0)]},
                        {key: 'organizer'},
                        {key: 'eventName'},
                        {key: 'kitEvent', required: false},
                        {key: 'date'},
                        {key: 'eventLocality'},
                        {key: 'attendees', validators: [gt(0)]},
                        {key: 'notes', required: false},
                        {key: 'address',
                            initial: getDefaultAddress(this.props.addressesData)},
                    ])}
                    errors={this.props.errors}
                    onSubmit={this.props.onSubmit}>
                    {({getFieldProps, renderErrors, isValid, values}) => (
                        <Fragment>
                            <Field label='Presupuesto estimado en pesos'>
                                <Input type='number' {...getFieldProps('estimatedAmount')} />
                                {renderErrors('estimatedAmount')}
                            </Field>
                            <Field label='Organizador' helpText='AACREA, AAPRESID, INTA, etc.'>
                                <Input type='text' {...getFieldProps('organizer')} />
                                {renderErrors('organizer')}
                            </Field>
                            <Field label='Evento' helpText='JAT, UPA, etc.'>
                                <Input type='text' {...getFieldProps('eventName')} />
                                {renderErrors('eventName')}
                            </Field>
                            <Field>
                                <Toggle
                                    type='checkbox'
                                    label='Incluye kit de evento'
                                    {...getFieldProps('kitEvent')}
                                />
                                {renderErrors('kitEvent')}
                            </Field>
                            <Field label='Fecha'>
                                <DateInput min={moment().format('YYYY-MM-DD')} {...getFieldProps('date')} />
                                {renderErrors('date')}
                            </Field>
                            <Field label='Localidad del evento'>
                                <LocalitySelect {...this.props.getLocalitySelectProps(getFieldProps('eventLocality'))} />
                                {renderErrors('eventLocality')}
                            </Field>
                            <Field label='Cantidad de invitados'>
                                <Input type='number' {...getFieldProps('attendees')} />
                                {renderErrors('attendees')}
                            </Field>
                            <Field label='Comentarios para Nidera'>
                                <Textarea {...getFieldProps('notes')} />
                                {renderErrors('notes')}
                            </Field>
                            <Field label='Dirección de envío de los kits'>
                                <AddressGrid
                                    addresses={this.props.addressesData.addresses}
                                    returnUrl={this.props.match.path}
                                    returnData={values}
                                    {...getFieldProps('address')}
                                />
                                {renderErrors('address')}
                            </Field>
                            {renderErrors('__all__')}
                            <Form.Actions>
                                <Button theme='yellow' disabled={!isValid() || this.props.loading}>
                                    {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                </Button>
                            </Form.Actions>
                        </Fragment>
                    )}
                </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/jt-dealer/index.js